<template>
  <div class="login-container">
    <div class="login-form-container">
      <div class="enter-stp3 login-enter biometric-success">
        <img src="assets/img/svg/logo-myMedical.svg" alt="logo" />
        <div class="title title--55 ft--400">נרשמת בהצלחה!</div>
        <div class="biometric-success-icon">
          <img :src="biometricIconPath" alt="biometric icon" />
        </div>
        <div class="subtitle">זיהוי ביומטרי הופעל בהצלחה</div>
        <div class="success-message">
          עכשיו תוכל להתחבר בקלות ובמהירות<br />
          באמצעות זיהוי ביומטרי
        </div>
        <div class="form_submit">
          <button class="bt_blue" @click="continueToApp">המשך לאפליקציה</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BiometricSuccess",
  computed: {
    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },
    biometricIconPath() {
      return this.isIOS
        ? "/assets/img/svg/faceid.svg"
        : "/assets/img/svg/fingerprint.svg";
    }
  },
  methods: {
    continueToApp() {
      // Navigate to the main app based on device type
      const isMobile = window.innerWidth < 1200;
      if (isMobile) {
        this.$router.push({ name: "lobby" });
      } else {
        this.$router.push({ name: "Dashboard" });
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-form-container {
  max-width: 650px;
  width: 100%;
  margin: 0 auto;
}

.biometric-success {
  text-align: center;
}

.biometric-success-icon {
  margin: 30px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.biometric-success-icon img {
  width: 80px;
  height: 80px;
  filter: brightness(0) saturate(100%) invert(21%) sepia(49%) saturate(1171%)
    hue-rotate(209deg) brightness(93%) contrast(95%);
}

.success-message {
  font-size: 22px;
  color: #2c2c2c;
  margin: 25px 0;
  line-height: 1.4;
  opacity: 0.8;
}

.biometric-success .title {
  color: var(--blue);
  margin: 25px 0 15px 0;
}

.biometric-success .subtitle {
  font-size: 24px;
  color: var(--blue-dark);
  font-weight: 400;
  margin: 15px 0;
}

.biometric-success .form_submit {
  margin-top: 40px;
}

.biometric-success .bt_blue {
  background: var(--blue);
  color: white;
  border: none;
  padding: 15px 40px;
  font-size: 26px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: NextExit, "Roboto Condensed";
  min-width: 200px;
}

.biometric-success .bt_blue:hover {
  background: var(--blue-dark);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(50, 73, 151, 0.3);
}

@media screen and (max-width: 1200px) {
  .biometric-success-icon img {
    width: 60px;
    height: 60px;
  }

  .success-message {
    font-size: 18px;
  }

  .biometric-success .title {
    font-size: 32px;
  }

  .biometric-success .subtitle {
    font-size: 20px;
  }

  .biometric-success .bt_blue {
    font-size: 22px;
    padding: 12px 30px;
  }
}
</style>
